import React from 'react'

import { ContainerStyled } from './styles'
interface ContainerProps {
  fullwidth?: boolean
}

export const Container: React.FC<ContainerProps> = ({ children, fullwidth = false }) => (
  <ContainerStyled maxWidth="lg" disableGutters fullwidth={fullwidth ? 'true' : 'false'}>
    {children}
  </ContainerStyled>
)
